import React from 'react';

const SkeletonLine = ({ className = '' }) => (
  <span className={`task-skeleton-line ${className}`}></span>
);

const TaskSkeletonGroup = ({ index }) => (
  <div className="task-loader-group">
    <div className="task-loader-customer">
      <SkeletonLine className="task-loader-sl" />
      <SkeletonLine className="task-loader-customer-name" />
      <SkeletonLine className="task-loader-contact" />
      <SkeletonLine className="task-loader-contact hidden md:block" />
      <span className="ml-auto flex gap-1">
        <SkeletonLine className="task-loader-mini-dot" />
        <SkeletonLine className="task-loader-icon-btn" />
      </span>
    </div>
    <div className="task-loader-row">
      <div className="task-loader-main">
        <SkeletonLine className="task-loader-id" />
        <SkeletonLine className="task-loader-logo" />
        <SkeletonLine className="task-loader-priority" />
        <SkeletonLine className={`${index % 3 === 0 ? 'task-loader-title-wide' : 'task-loader-title'}`} />
        <SkeletonLine className="task-loader-set" />
      </div>
      <div className="task-loader-statuses">
        <SkeletonLine className="task-loader-status" />
        <SkeletonLine className="task-loader-status hidden sm:block" />
        <SkeletonLine className="task-loader-price" />
        <SkeletonLine className="task-loader-date hidden lg:block" />
      </div>
      <div className="task-loader-options">
        <SkeletonLine className="task-loader-option hidden xl:block" />
        <SkeletonLine className="task-loader-option hidden xl:block" />
        <SkeletonLine className="task-loader-option hidden 2xl:block" />
      </div>
      <div className="task-loader-actions">
        {Array.from({ length: 5 }).map((_, actionIndex) => (
          <SkeletonLine key={actionIndex} className="task-loader-icon-btn" />
        ))}
      </div>
    </div>
  </div>
);

const PageLoader = ({ title = 'Loading workspace', rows = 12 }) => {
  return (
    <div className="main-bodyLayout">
      <div className="task-loader-shell">
        <div className="task-loader-command">
          <div className="task-loader-identity">
            <SkeletonLine className="task-loader-logo-large" />
            <div className="min-w-0">
              <SkeletonLine className="task-loader-kicker" />
              <SkeletonLine className="task-loader-heading" />
            </div>
          </div>
          <div className="task-loader-search">
            <SkeletonLine className="task-loader-search-toggle" />
            <SkeletonLine className="task-loader-search-input" />
          </div>
          <SkeletonLine className="task-loader-add" />
          <div className="task-loader-filter-row">
            {Array.from({ length: 7 }).map((_, index) => (
              <SkeletonLine key={index} className="task-loader-filter" />
            ))}
          </div>
        </div>

        <div className="task-loader-meta">
          <span>{title}</span>
          <SkeletonLine className="task-loader-count" />
        </div>

        <div className="task-loader-list">
          {Array.from({ length: rows }).map((_, index) => (
            <TaskSkeletonGroup key={index} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export const InlineLoader = ({ text = 'Loading' }) => (
  <div className="task-inline-state">
    <span className="w-4 h-4 border-2 rounded-full animate-spin border-slate-300 border-t-orange-500 dark:border-slate-700 dark:border-t-orange-600"></span>
    <span>{text}</span>
  </div>
);

export const EmptyState = ({ title = 'No data yet', message = 'New items will appear here as soon as they are available.' }) => (
  <div className="task-empty-state">
    <div className="flex items-center justify-center w-10 h-10 mx-auto mb-3 rounded-full bg-slate-200 dark:bg-slate-800">
      <span className="w-2.5 h-2.5 rounded-full bg-orange-500 dark:bg-orange-600"></span>
    </div>
    <h3 className="text-sm font-bold text-slate-600 dark:text-slate-300">{title}</h3>
    <p className="mt-1 text-xs text-slate-400 dark:text-slate-500">{message}</p>
  </div>
);

export default PageLoader;
